// Chakra imports
import { SimpleGrid, Text, useColorModeValue, Spinner, Center } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Information from "views/admin/profile/components/Information";
import ToggleInformation from "views/admin/profile/components/ToggleInformation";

import constants from "providers/Constants";
import useAuthentication from "providers/Authentication";

// Assets
export default function Settings(props) {

  const authentication = useAuthentication();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const { developer, uploads, ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  useEffect(() => {

  }, [developer, uploads]);

  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      {loading ? (
        <Center w='100%' minH={rest?.minH || '220px'}>
          <Spinner size="xl" />
        </Center>
      ) : (
        <>
          <SimpleGrid columns='2' gap='20px'>
            <ToggleInformation
              title={t('Webhooks')}
              boxShadow={cardShadow}
              value={!!developer?.enable_webhooks}
              onChange={v => {
                developer['enable_webhooks'] = v;
                updateProfile('enable_webhooks', v);
              }}
            />
            <Information
              boxShadow={cardShadow}
              title={t('Webhook URL')}
              input_type={'url'}
              value={`${developer?.webhook_url || t('N/A')}`}
              onChange={e => {
                developer['webhook_url'] = e;
                updateProfile('webhook_url', e);
              }}
            />
            <Information
              boxShadow={cardShadow}
              title={t('Logo')}
              upload={true}
              upload_array={uploads}
              hint={t('HINT: Select file from your uploads on BlockMap. Use the file uploader tool to upload files')}
              value={`${developer?.business_logo || t('N/A')}`}
              onChange={e => {
                developer['business_logo'] = e;
                updateProfile('business_logo', e);
              }}
            />
            <ToggleInformation
              title={t('Email Alerts')}
              boxShadow={cardShadow}
              value={!!developer?.enable_email_alerts}
              onChange={v => {
                developer['enable_email_alerts'] = v;
                updateProfile('enable_email_alerts', v);
              }}
            />
            <ToggleInformation
              title={t('Notifications')}
              boxShadow={cardShadow}
              value={!!developer?.enable_notifications}
              onChange={v => {
                developer['enable_notifications'] = v;
                updateProfile('enable_notifications', v);
              }}
            />
          </SimpleGrid>
        </>
      )}
    </Card>
  );

  // Update profile
  async function updateProfile(key, value) {
    setLoading(true);
    const data = {
      [key]: value,
    }
    authentication.updateUser(data, (error, data) => {
      setLoading(false);
      if (error) {
        constants.showToast(
          "error",
          t('FAILED'),
          error?.message || t('Snap! Something went wrong, Try again')
        );
      } else {
        constants.showToast(
          "success",
          t('SUCCESS'),
          t('Profile updated successfully')
        );
      }
    });
  }
}
